module.exports = __webpack_public_path__ + "static/img/专题活动页设计-插画类活动页.b727244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/专题活动页设计-插画类活动页.png
// module id = a20i
// module chunks = 1